const edsIitCheckboxSteps = {
  computed: {
    steps() {
      return {
        options: 'options',
        fileSign: 'fileSign',
        savedKeys: 'savedKeys',
        smartIdRead: 'smartIdRead',
        smartIdSign: 'smartIdSign',
        cloudSignatureQrRead: 'cloudSignatureQrRead',
        cloudSignatureQrSign: 'cloudSignatureQrSign',
        keyInfo: 'keyInfo',
        diiaRead: 'diiaRead',
        diiaSign: 'diiaSign',
        monoRead: 'monoRead',
        monoSign: 'monoSign'
      }
    }
  }
}

export default edsIitCheckboxSteps
